export default `
<svg
  aria-hidden="true"
  aria-label="sequential"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <path
    d="M5 5V18"
    stroke="currentcolor"
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M2 15L5 18L8 15"
    stroke="currentcolor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <text
    x="11"
    y="11"
    font-size="12"
    font-weight="600"
    font-family="Arial, Helvetica, sans-serif"
    fill="currentcolor"
  >1</text>
  <text
    x="11"
    y="22"
    font-size="12"
    font-weight="600"
    font-family="Arial, Helvetica, sans-serif"
    fill="currentcolor"
  >2</text>
</svg>
`;
